import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const adminApi = {
  overview: () => axios.get(`${API}/admin/overview`).then((r) => r.data),
  notifications: () => axios.get(`${API}/admin/notifications`).then((r) => r.data),
  readNotifications: () => axios.post(`${API}/admin/notifications/read`).then((r) => r.data),
  applications: () => axios.get(`${API}/admin/applications`).then((r) => r.data),
  updateApplication: (id, status) => axios.patch(`${API}/admin/applications/${id}`, { status }).then((r) => r.data),
  employerRequests: () => axios.get(`${API}/admin/employer-requests`).then((r) => r.data),
  updateRequest: (id, status) => axios.patch(`${API}/admin/employer-requests/${id}`, { status }).then((r) => r.data),
  users: () => axios.get(`${API}/admin/users`).then((r) => r.data),
  createJob: (payload) => axios.post(`${API}/admin/jobs`, payload).then((r) => r.data),
  updateJob: (id, payload) => axios.put(`${API}/admin/jobs/${id}`, payload).then((r) => r.data),
  deleteJob: (id) => axios.delete(`${API}/admin/jobs/${id}`).then((r) => r.data),
  jobs: () => axios.get(`${API}/jobs`).then((r) => r.data),
  threads: () => axios.get(`${API}/admin/threads`).then((r) => r.data),
  thread: (userId) => axios.get(`${API}/admin/threads/${userId}`).then((r) => r.data),
  sendMessage: (payload) => axios.post(`${API}/admin/messages`, payload).then((r) => r.data),
};

export const APP_STATUSES = ["received", "contacted", "screening", "placed", "closed"];
export const REQ_STATUSES = ["open", "matching", "filled", "closed"];

export const STATUS_TONE = {
  received: "text-[#0099FF] border-[#0099FF]/40 bg-[#0099FF]/10",
  contacted: "text-[#FFB800] border-[#FFB800]/40 bg-[#FFB800]/10",
  screening: "text-[#FFB800] border-[#FFB800]/40 bg-[#FFB800]/10",
  placed: "text-[#10B981] border-[#10B981]/40 bg-[#10B981]/10",
  closed: "text-[#8FA3B8] border-white/20 bg-white/5",
  open: "text-[#0099FF] border-[#0099FF]/40 bg-[#0099FF]/10",
  matching: "text-[#FFB800] border-[#FFB800]/40 bg-[#FFB800]/10",
  filled: "text-[#10B981] border-[#10B981]/40 bg-[#10B981]/10",
};
